// extracted by mini-css-extract-plugin
export default {"ScrollUp":"ScrollUp_ScrollUp__gb10G"};